import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges, SimpleChange, ViewChild, ElementRef} from '@angular/core';
import {AssetService} from '../../shared/asset.service';
import {UserService} from '../../user/user.service';
import {DPUserService, DPSubscriptionService} from '../../portalv1';
import {ToasterService} from 'angular2-toaster';
import {UserDetailsService} from '../../shared/user.details.service';
import {InAppNotificationsService} from '../../notifications/notifications.service';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';
import {VideoService} from '../model/video.service';
import {ClipboardService} from 'ngx-clipboard';

declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'talent-video-manage',
    templateUrl: 'talent-video-manage.component.html',
    styleUrls: ['talent-video-manage.service.scss']
})
export class TalentVideoManageComponent implements OnInit {
    @ViewChild('modal', {read: ElementRef}) modal: ElementRef;
    @Input() selectedShow;
    @Input() classificationTypeValue;
    selectedConfidenceLevel: any;
    selectedPage: any;
    originalData;
    dataLoaded = false;
    @Output() selectedShowChange = new EventEmitter();
    tabs = ['high', 'medium', 'low'];
    selectedTab = 'high';
    editMode = false;
    showComponent = false;
    editLoading = false;
    imdbChanged = [];
    importLoading = false;
    harvestedQARequest;
    rejectMessage = '';
    rejectModalLoading = false;
    genres = null;
    languages = null;
    countries = null;
    titlesToAdd = [];
    private selectAll = false;
    private results = [];
    private hasMore = false;
    private hasResults = false;


    private verifyStatusValue = 'Approved';

    private verifyStatusCheckBox = {
        verifyState: true,

    };
    private page = 0;
    private maxPages = 1;
    private imdb_id = undefined;
    private wikibase_id = undefined;
    private google_search = undefined;
    private totalResults;
    private confidenceBreakdown = [];
    private descriptionToBeShowed: string;
    private viewType: number = 0;
    private viewTypeValue = '0';
    private approvalTypeValue = '1';
    private currentDate;
    private tagsToBeShowed;
    private currentYear;
    private givenYear;

    constructor(private clip: ClipboardService, private catalogService: CatalogService, private videoService: VideoService,
                public assetService: AssetService,
                private userService: UserService,
                private userDetailsService: UserDetailsService,
                private dpUserService: DPUserService,
                private notificationService: InAppNotificationsService,
                private toasterService: ToasterService) {
    }


    onOriginalKeyUp(value, type, videoId) {
        switch (type) {
            case 'verifyState':
                this.verifyStatusValue = value;
                this.results = this.results.map((item) => {
                    if (item.video_id === videoId) {
                        item.human_verified = value;
                    }
                    return item;
                });
                break;
        }
    }

    onHumanVerfiedKeyUp(value, type, videoId) {
        switch (type) {
            case 'verifyState':
                this.verifyStatusValue = value;
                this.results = this.results.map((item) => {
                    if (item.video_id === videoId) {
                        item.human_verified = value;
                    }
                    return item;
                });
                break;
        }
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    ngOnInit(): void {
    }

    // tslint:disable-next-line:use-life-cycle-interface member-ordering
    popup: boolean;

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedShow) {
            const selectedShow: SimpleChange = changes.selectedShow;
            if (selectedShow.currentValue) {
                if (selectedShow.currentValue.parrot_id) {
                    this.dataLoaded = false;
                    this.editMode = false;
                    this.page = 0;
                    this.getVideos(selectedShow.currentValue, 'HIGH', 0, this.classificationTypeValue);
                } else {
                    this.hideDetails();
                }
            }

        }

    }

    isLoading(): boolean {
        return this.editLoading || this.rejectModalLoading || this.importLoading;
    }

    async submitChanges() {
        const approvedUpdateQuery = [];
        const rejectedUpdateQuery = [];
        const nonContentTypeUpdateQuery = [];

        this.results = this.results.map((item) => {
            if (item.human_verified === 'APPROVED') {
                approvedUpdateQuery.push(item.video_id);
            }
            return item;
        });

        this.results = this.results.map((item) => {
            if (item.human_verified === 'REJECTED') {
                rejectedUpdateQuery.push(item.video_id);
            }
            return item;
        });

        this.results = this.results.map((item) => {
            if (item.human_verified === 'NON_ENTITY_TYPE') {
                nonContentTypeUpdateQuery.push(item.video_id);
            }
            return item;
        });


        const queryJSON = {
            'parrot_id': this.selectedShow.parrot_id,
            'title': (this.selectedShow.title).toLowerCase(),
            'classification_type' : this.classificationTypeValue,
            'approved_video_ids': approvedUpdateQuery,
            'rejected_video_ids': rejectedUpdateQuery,
            'non_entity_video_ids': nonContentTypeUpdateQuery
        };

        try {

            const res = await this.videoService.updateTalentVideoResults(
                JSON.stringify(queryJSON));


            if (res == null) {
                if (this.totalResults > (this.page)) {
                    this.page = this.page;
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }

                this.dataLoaded = false;

                this.getVideos(this.selectedShow, this.selectedTab, this.page, this.classificationTypeValue);
                this.toasterService.pop('info', 'Successfully Updated the Videos');
                this.dataLoaded = true;
            } else {
                this.toasterService.pop('error', 'Failed to get video results');
                this.dataLoaded = false;
            }
        } catch (err) {
            console.error('Failed to get video results in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to get video results');
            this.dataLoaded = false;
        }


    }

    handleNextPage() {
        this.handleGoToPage(this.page + 1);
    }

    handlePreviousPage() {
        this.handleGoToPage(this.page - 1);
    }

    handleGoToPage(page) {
        this.selectAll = false;
        this.page = page;
        this.getVideos(this.selectedShow, this.selectedTab, this.page, this.classificationTypeValue);
    }

    getVideos(show, confidenceLevel, pageNumber, classificationTypeValue) {
        this.showComponent = true;
        this.selectedShow = show;
        this.selectedShowChange.emit(this.selectedShow);
        this.dataLoaded = false;
        this.getMetaData(show, confidenceLevel, pageNumber, classificationTypeValue);
    }

    viewImdbId(value) {
        const newWindow = window.open('https://www.imdb.com/name/' + value);
    }

    viewWikibaseId(value) {
        const newWindow = window.open('https://www.wikidata.org/wiki/' + value);
    }

    viewGoogleSearch(value) {
        const newWindow = window.open('https://www.google.com/search?q=' + value);
    }

    async getMetaData(show, confidenceLevel, pageNumber, classificationTypeValue) {

        this.currentDate = new Date().toISOString().slice(0, 10);
        const currentYear = new Date().getFullYear().toString();
        // tslint:disable-next-line:radix
        this.currentYear = parseInt(currentYear);
        try {
            if (this.selectedShow.imdb_id) {
                this.imdb_id = this.selectedShow.imdb_id;
            }
            if (this.selectedShow.wikibase_id) {
                this.wikibase_id = this.selectedShow.wikibase_id;
            }
            if (this.selectedShow.birth_date) {
                // tslint:disable-next-line:max-line-length
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.primary_occupation + ' ' + this.selectedShow.birth_date;
            } else if (this.selectedShow.birth_year) {
                // tslint:disable-next-line:max-line-length
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.primary_occupation + ' ' + this.selectedShow.birth_year;
            } else {
                this.google_search = this.selectedShow.title + ' ' + this.selectedShow.primary_occupation + ' ' + this.selectedShow.birth_date;
            }
        } catch (ex) {
            console.error('Fail to get links');
        }
        try {
            // tslint:disable-next-line:radix
            this.givenYear = parseInt(this.selectedShow.release_year);
        } catch (ex) {
            console.error('Fail to parse release year');
        }

        try {
            const value = this.viewType;
            let pageSize = 24;
            if (value === 1) {
                pageSize = 25;
            } else if (value === 2) {
                pageSize = 18;
            } else if (value === 3) {
                pageSize = 25;
            } else if (value === 0) {
                pageSize = 24;
            }

            const parrotID = show.parrot_id;
            try {
                const res = await this.videoService.getTalentVideos(
                    parrotID, confidenceLevel, pageNumber, classificationTypeValue);
                this.results = [];
                this.confidenceBreakdown = [];
                if (res.results.length > 0) {
                    this.hasResults = true;
                    this.results = this.results.concat(res.results.map(item => this.videoService.mapTalentIndividualVideoResultItem(item, parrotID)));
                } else {
                    this.hasResults = false;
                }
                this.confidenceBreakdown = res.confidence_breakdown.map(item => this.videoService.mapTalentIndividualConfidenceBreakdown(item));
                this.confidenceBreakdown = this.parseConfidenceBreakdown(this.confidenceBreakdown);
                this.totalResults = res.page_info.maxpage - 1;
                if (this.totalResults > (this.page)) {
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }
                this.dataLoaded = true;

            } catch (err) {
                this.dataLoaded = true;
                console.error('Failed to get video results in the catalog API' + err.toString());
                this.toasterService.pop('error', 'Failed to get video results');
            }

            this.originalData = jQuery.extend(true, {}, this.results);
            this.selectedShowChange.emit(this.results);
        } catch (error) {
            this.dataLoaded = true;
        }
    }

    private parseConfidenceBreakdown(confidenceBreakdown) {

        let lowCount = 0;
        let lowApprovedCount = 0;
        let lowRejectedCount = 0;
        let lowPendingCount = 0;
        let highCount = 0;
        let highApprovedCount = 0;
        let highRejectedCount = 0;
        let highPendingCount = 0;
        let medCount = 0;
        let medApprovedCount = 0;
        let medRejectedCount = 0;
        let medPendingCount = 0;

        for (const value of confidenceBreakdown) {

            if (value.confidence_level === 'UNKNOWN' || value.confidence_level === 'low') {
                lowCount = lowCount + value.total_count;
                lowApprovedCount = lowApprovedCount + value.total_approved;
                lowRejectedCount = lowRejectedCount + value.total_rejected;
                lowPendingCount = lowPendingCount + value.total_pending;

            }
            if (value.confidence_level === 'VHIGH' || value.confidence_level === 'high') {
                highCount = highCount + value.total_count;
                highApprovedCount = highApprovedCount + value.total_approved;
                highRejectedCount = highRejectedCount + value.total_rejected;
                highPendingCount = highPendingCount + value.total_pending;

            }
            if (value.confidence_level === 'medium') {
                medCount = medCount + value.total_count;
                medApprovedCount = medApprovedCount + value.total_approved;
                medRejectedCount = medRejectedCount + value.total_rejected;
                medPendingCount = medPendingCount + value.total_pending;
            }

            confidenceBreakdown = [
                {
                    'confidence_level': 'low',
                    'total_count': lowCount,
                    'total_approved': lowApprovedCount,
                    'total_rejected': lowRejectedCount,
                    'total_pending': lowPendingCount
                },
                {
                    'confidence_level': 'high',
                    'total_count': highCount,
                    'total_approved': highApprovedCount,
                    'total_rejected': highRejectedCount,
                    'total_pending': highPendingCount
                },
                {
                    'confidence_level': 'medium',
                    'total_count': medCount,
                    'total_approved': medApprovedCount,
                    'total_rejected': medRejectedCount,
                    'total_pending': medPendingCount
                }
            ];
        }

        return confidenceBreakdown;
    }

    selectTab(tab) {
        this.selectedTab = tab;
        this.selectedConfidenceLevel = tab;
        this.page = 0;

        this.getVideos(this.selectedShow, this.selectedConfidenceLevel, this.page, this.classificationTypeValue);
    }

    closeModal() {
        this.modal.nativeElement.style.display = 'none';
    }

    hideDetails() {
        this.showComponent = false;
    }

    handleSelectAll() {
        this.selectAll = !this.selectAll;
        this.results = this.results.map((item) => {
            item.selected = this.selectAll;
            item.human_verified = 'APPROVED';
            return item;
        });
    }

    handleRejectAll() {
        this.selectAll = !this.selectAll;
        this.results = this.results.map((item) => {
            item.selected = this.selectAll;
            item.human_verified = 'REJECTED';
            return item;
        });
    }

    handleClearAll() {
        this.getVideos(this.selectedShow, this.selectedTab, this.page, this.classificationTypeValue);
    }

    descriptionPopUp(event: boolean, description: string, tags: any) {

        this.popup = event;
        this.descriptionToBeShowed = description;
        this.tagsToBeShowed = tags;

    }
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/talent-video-manage/talent-video-manage.component.ts